var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanpassport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 100,
    height: 80,
    viewBox: "0 0 248.4 139.9",
    style: {
      enableBackground: "new 0 0 248.4 139.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#74977E;}\n\t.st1{fill:#74997E;}\n\t.st2{fill:#D9EAE0;}\n\t.st3{fill:none;}\n\t.st4{fill:none;stroke:#369E3B;stroke-width:1.98;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{opacity:0.8;fill:#CBCBCB;}\n\t.st6{fill:#D8E8DE;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#CAD1D4;}\n\t.st9{opacity:0.13;fill:#000201;enable-background:new    ;}\n\t.st10{fill:none;stroke:#379C3B;stroke-width:1.78;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Lager_7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,80.6l29.1,29.9L163,138.8c0,0-4,3.4-7.1-1.6s-41.1-57.8-41.1-57.8s31-23.7,39.4-21.7L176,80.6L176,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.4,56.6l28.9-33c0,0,3.3-5.5,8.2,0l52.6,39.9c0,0,6.3,3.5,1.6,9.1l-40.6,37.5L155.4,56.6L155.4,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.8,79.7l29.2,30.8l-42.3,27.3c0,0-4,3.4-7.1-1.6s-41.1-57.8-41.1-57.8s31.1-23.7,39.4-21.7L175.8,79.7 L175.8,79.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "147.4,60.7 159.1,73.9 138.5,86.6 127.3,72.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 123.8,
    y1: 75,
    x2: 123.8,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 123.8,
    y1: 75,
    x2: 166.3,
    y2: 131.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 121.1,
    y1: 77.4,
    x2: 163.1,
    y2: 134.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128.5,18.6l39.4,112.1c0.8,1.9-0.8,2.6-2.2,4l-1.5,1.2c-1.3,1.2-4.1-2.2-6-4.1l-36.7-49.5 c-2.1-2.7-3.5-4.6-3.3-6.9l9.1-53.3C127.5,20.8,127.6,19.4,128.5,18.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,35c0,0,6.1,5.4-1.8,12.7c-7.9,7.2-109.9,84.1-109.9,84.1s-11.5,10.3-21.2-2.6L1.7,83.9l-0.2-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3.7,76l5.1-3.3l10.3-6.9l89.1-62.7c5.6-4.1,9.5-4.7,15.9,1.3l29.4,26.4c6.6,5.5,6.8,9.9-1.6,16L41.4,131.6 c-6.8,4.8-11.9,1.9-16.7-4.9L5.6,90.6l-3.4-5.8C2.2,84.8-2,79.4,3.7,76L3.7,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M119,3.8c-1-1.5-5.6-1.8-7.5-0.5L12,73.9c-4.8,3.4-5.5,3.6-6.2,4.8L34,127.5c1,1.5,3,1.6,4.8,0.3L153,41.4 c3.8-2.9-0.4-6.8-1.5-8.2L119,3.8L119,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M99.3,82.1L153,41.4c3.8-2.9,0.4-7.3-0.8-8L119,3.2c-1-1.5-5.6-1.8-7.5-0.5L64.2,36.8L99.3,82.1L99.3,82.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5516 -0.8341 0.8341 0.5516 -67.3941 68.2689)",
    className: "st6",
    cx: 29.8,
    cy: 96.8,
    rx: 6.5,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,98c0.1-0.2,0.1-0.3,0-0.5c0-0.2-0.2-0.3-0.4-0.3l-3.2-0.4l0.4-0.7c0.1-0.2,0.2-0.5,0.1-0.7 c0-0.1-0.1-0.2-0.2-0.3c-0.3-0.1-0.7,0-0.9,0.4l-1,1.6C27,97.3,27,97.6,27,97.8v0c0.1,0.2,0.2,0.3,0.4,0.3l4,0.5 C31.7,98.7,32.1,98.4,32.2,98L32.2,98z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "77.2,27.3 113.7,71 127.4,60.6 90.2,17.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 88.2,
    y1: 24.5,
    x2: 119.9,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 84.7,
    y1: 26.3,
    x2: 116.3,
    y2: 64.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.1,56.3l29.1-33.7c0,0,3.3-5.5,8.2,0L245,62.5c0,0,6.3,3.5,1.6,9.1l-40.5,38.5L155.1,56.3L155.1,56.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lager_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lager_2_00000163763619237901160010000012255464083366151057_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lager_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lager_6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanpassport);
export default __webpack_public_path__ + "static/media/scanpassport.774d275d123d0fe5b516a72684f176e2.svg";
export { ForwardRef as ReactComponent };